import psl from 'psl';
import blocklistedEmailDomains from './blocklistedEmailDomains.json';

export const emailValidator = (email: string): boolean => {
    const EMAIL_REGEX = /^([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

    if (EMAIL_REGEX.test(email.trim())) {
        const domain = email.split('@')[1];
        return psl.isValid(domain);
    }
    return false;
};

export const passwordValidator = (password: string): boolean => {
    const PASSWORD_REGEX = /(?=.*\d)(?=.*[a-zA-Z]).{8,30}$/;

    return PASSWORD_REGEX.test(password.trim());
};

export const phoneValidator = (phone: string): boolean => {
    const PHONE_REGEX = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

    return PHONE_REGEX.test(phone.trim());
};

export const emailDomainValidator = (email: string): boolean => {
    const [, domain] = email?.trim()?.match(/@(.+)/) || [];
    return !blocklistedEmailDomains.includes(domain);
};

export const nameValidator = (name: string): boolean => {
    const NAME_REGEX = /^[a-zA-Z.-]*$/;
    return NAME_REGEX.test(name);
};
